// extracted by mini-css-extract-plugin
module.exports = {"maxwidth":"index_maxwidth__1pAS5"};